// extracted by mini-css-extract-plugin
export var collapsedSummary = "_si-0";